import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "./AuthShell";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { Checkbox } from "../../components/ui/checkbox";

export default function Login({ admin }) {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, adminLogin } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = admin ? await adminLogin(username, password) : await login(email, password);
      toast.success("Welcome back");
      const from = loc.state?.from;
      if (u.role === "admin") navigate("/admin");
      else navigate(from || "/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell admin={admin} title={admin ? "Admin sign in" : "Sign in"} subtitle={admin ? "KERA management portal — username & password" : "Access your candidate account"}
      footer={admin ? <Link className="text-[#8a6a1e] font-medium hover:underline" to="/login">Candidate login →</Link>
        : <>New to KERA? <Link className="text-[#8a6a1e] font-medium hover:underline" to="/register">Create a candidate profile</Link></>}>
      <form onSubmit={submit} className="space-y-5">
        {admin ? (
          <div>
            <Label htmlFor="username">Username</Label>
            <Input id="username" data-testid="login-username-input" required value={username} onChange={(e) => setUsername(e.target.value)}
              className="mt-1.5 bg-white" placeholder="e.g. superadmin" autoComplete="username" />
          </div>
        ) : (
          <div>
            <Label htmlFor="email">Email address</Label>
            <Input id="email" data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 bg-white" placeholder="you@example.com" />
          </div>
        )}
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 bg-white" placeholder="••••••••" />
        </div>
        {!admin && (
          <div className="flex items-center justify-between">
            <label className="flex items-center gap-2 text-sm text-muted-foreground"><Checkbox data-testid="remember-me-checkbox" /> Remember me</label>
            <Link to="/forgot-password" className="text-sm text-[#8a6a1e] hover:underline">Forgot password?</Link>
          </div>
        )}
        <Button data-testid="login-submit-button" disabled={loading} type="submit"
          className="w-full bg-[#101820] hover:bg-[#1A242F] text-[#FAF6EE] rounded-full h-11 font-semibold">
          {loading ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </AuthShell>
  );
}
